import { toast } from "react-toastify";
import AuthPage from "./pages/Authenticate/AuthPage";
import APIStatus from "./pages/APIStatus";
import FBGraph from "./pages/Pricing/FBGraphPricing";
import TikTokPricing from "./pages/Pricing/TikTokPricing";
import AdminPanel from "./pages/AdminPanel/AdminPanel";
import Profile from "./pages/Profile/Profile";
import { ChartArea, FacebookIcon, House, Key, LogInIcon, Recycle, User } from "lucide-react";
import FBGraphDocs from "./pages/Docs/FBGraphDocs";
import MyAccessToken from "./pages/MyAccessToken/MyAccessToken";
import Services from "./services/services";
import { setCurrentUser } from "./reducers/authSlice";
import TiktokDocs from "./pages/Docs/TiktokDocs";
import ForgottenPassword from "./pages/Authenticate/ForgottenPassword";
import FBActionDocs from "./pages/Docs/FBActionDocs";
import FBActionPricing from "./pages/Pricing/FBActionPricing";
import LandingPage from "./pages/LandingPage";

export const USD_TO_VND_RATE = 17500;
export const toastCustom = (message, buttons = []) => {
    toast(({ closeToast }) => (
        <div>
            <div className="mb-2">{message}</div>
            <div className="flex gap-2 justify-end">
                {buttons.map((button, index) => (
                    <button
                        key={index}
                        className={`px-3 py-1 rounded transition-all duration-200 ${button.className}`}
                        onClick={button.onClick}
                    >
                        {button.label}
                    </button>
                ))}
            </div>
        </div>
    ), { autoClose: false });
}

export const RoutePages = {
    HOME:{
        path: "/",
        "name": "Home",
        "icon": <House />,
        element: <LandingPage />,
    },
    AUTH: {
        path: "/auth",
        "name": "Authentication",
        "icon": <LogInIcon />,
        element: <AuthPage />,
    },
    FORGOTTEN_PASSWORD:{
        path: "/forgotten-password",
        "name": "Forgotten Password",
        "icon": <Recycle />,
        element: <ForgottenPassword />,
    },
    API_STATUS: {
        path: "/api-status",
        "name": "API Status",
        "icon": <ChartArea />,
        element: <APIStatus />,
    },
    PRICING: {
        FB_GRAPH: {
            path: "/pricing/fb_graph",
            "name": "Facebook Graph API",
            "icon": <FacebookIcon />,
            element: < FBGraph />,
        },
        TIKTOK: {
            path: "/pricing/tiktok",
            "name": "TikTok API",
            "icon": <FacebookIcon />,
            element: <TikTokPricing />,
        },
        FB_ACTION: {
            path: "/pricing/fb_action",
            "name": "Facebook Action API",
            "icon": <FacebookIcon />,
            element: <FBActionPricing />,
        },
    },
    ADMIN: {
        path: "/admin",
        "name": "ADMIN PANEL",
        "icon": <User />,
        element: < AdminPanel />,
    },
    MY_SUBSCRIPTIONS: {
        path: "/subscriptions",
        "name": "My Subscriptions",
        "icon": <Key />,
        element: <MyAccessToken />,
    },
    USER: {
        path: "/user",
        "name": "My Profile",
        "icon": <User />,
        element: <Profile />,
    },
    DOCS: {
        FB_GRAPH: {
            path: "/docs/fb-graph",
            "name": "Facebook Graph API",
            "icon": <FacebookIcon />,
            element: <FBGraphDocs />,
        },
        TIKTOK: {
            path: "/docs/tiktok",
            "name": "TikTok API",
            "icon": <FacebookIcon />,
            element: <TiktokDocs />,
        },
        FB_ACTION: {
            path: "/docs/fb-action",
            "name": "Facebook Action API",
            "icon": <FacebookIcon />,
            element: <FBActionDocs />,
        },
    }
}

export const fetchUserData = async (dispatch, navigate) => {
    const result = await Services.UserAuth.me();
    const data = await result.json();
    if (result.ok && data.success === true) {
        dispatch(setCurrentUser(data.data));
    }
    else {
        dispatch(setCurrentUser(null));
        navigate(RoutePages.AUTH.path);
        toast.error("Please login into your account!")
    }
}


export const handleGetFreemiumSubscription = async (service_callback, userStore, navigate) => {
    if (!userStore) {
        toast.info("Please register and login to get freemium subscription!");
        navigate(RoutePages.AUTH.path);
        return;
    }
    const res = await Services.Subscription.createFreemium(service_callback);
    const data = await res.json();
    if (res.ok && data.success) {
        toast.success("Successful got freemium subscription!");
        navigate(RoutePages.MY_SUBSCRIPTIONS.path);
    } else {
        toast.error(`code_${res.status}: ${data.error}`);
    }
};

export const getUnitPriceByRequestCount = (request_count, base_price_vnd) => {
    return base_price_vnd + (200000 / (request_count + 10000));
}

export const getConcurrencyByLimit = (requests_limit, base_price_vnd) => {
    const unitPrice = getUnitPriceByRequestCount(requests_limit, base_price_vnd);
    return Math.max(
        1,
        Math.round(
            5.2 * Math.log(Math.max(1, unitPrice * requests_limit)) / Math.log(8)
        ) - 26
    );
}

export const SERVICE_CALLBACK = {
    FB_GRAPH: "fb_graph",
    TIKTOK: "tiktok",
    FB_ACTION: "fb_action",
}

export const getVietQRURL = (account_number, amount, addInfo, accountName) => {
    return `https://img.vietqr.io/image/970422-${account_number}-compact.png?amount=${Math.round(amount)}&addInfo=${encodeURIComponent(addInfo)}&accountName=${encodeURIComponent(accountName)}`
}